"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHInputKeyRepeating = void 0;
const KHHelperFunctions_1 = require("../../KHHelperFunctions");
const KHInputKeyDerived_1 = require("./KHInputKeyDerived");
/**
 * An input key that will retrigger after an initial delay of X ms, and then
 * repeat every Y ms after that. This will only perceptively trigger once per
 * frame even if it did repeat more than once.
 *
 * This input can have a just down without a previous not down, so be aware if
 * you're chaining inputs on top of it.
 */
class KHInputKeyRepeating extends KHInputKeyDerived_1.KHInputKeyDerived {
    constructor(inputSet, key, initialDelay, incrementalDelay) {
        super(inputSet);
        this.key = key;
        this.initialDelay = initialDelay;
        this.incrementalDelay = incrementalDelay;
        this.downTime = null;
        this.lastTime = null;
    }
    updateDerivedInput(now) {
        if (this.key.isJustDown()) {
            this.downTime = now;
            this.lastTime = now;
            this.updateInternal(true, true);
            return;
        }
        else if (!this.key.isDown()) {
            this.updateInternal(false, false);
            return;
        }
        let lastDiff = this.lastTime - this.downTime;
        let diff = now - this.downTime;
        let justDown = false;
        if (KHHelperFunctions_1.isBetween(lastDiff, this.initialDelay, diff) || /* Initial delay elapsed */
            (diff > this.initialDelay && KHHelperFunctions_1.looped(lastDiff - this.initialDelay, this.incrementalDelay, diff - this.initialDelay))) { // More than incremental delay elapsed.
            justDown = true;
        }
        this.updateInternal(true, justDown);
        this.lastTime = now;
    }
}
exports.KHInputKeyRepeating = KHInputKeyRepeating;
